export const environment = {
  rootUrl: `${process.env.https://dev.api.digitalbuildings.xyz}/core`,
  keycloakUrl: `${process.env.https://dev.users.digitalbuildings.xyz}/auth`,
  keycloakServiceUrl: process.env.https://dev.api.digitalbuildings.xyz,
  keycloakRealm: 'zdb',
  keycloakClientId: 'core-edit-2',
  gatewayUrl: process.env.https://dev.api.digitalbuildings.xyz
}
